import Main from '@rhitics/sic/pages/Main.vue'
import BarcodeCard from '@rhitics/sic/components/BarcodeCard.vue'
import AssetsTable from '@rhitics/sic/components/AssetsTable.vue'

export default [
  {
    name: 'sic',
    path: '/sic',
    component: Main,
    meta: {
      title: 'SimpleInventoryCheck'
    },
    redirect: { name: 'asset-check' },
    children: [
      {
        path: 'barcode-generate',
        name: 'barcode-generate',
        component: BarcodeCard,
        meta: {
          title: 'SchedulerTasks'
        }
      },
      {
        name: 'asset-check',
        path: 'asset-check',
        component: AssetsTable,
        meta: {
          title: 'SchedulerSpecs'
        }
      }
    ]
  }
]
